import React, { useState } from "react";
import {
    Button,
    DialogTitle,
    Divider,
    DialogContent,
    DialogActions,
    TextField,
    InputAdornment,
    IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomDialog from "components/reusables/CustomDialog";
import { dispatchFunction, showToast } from "services/utils";
import withRouter from "./withRouter";

const ESign = (props) => {
    const {
        open,
        setOpen,
        handleSubmit,
        userData,
        buttonName = "",
        esignType = "",
        color = "",
    } = props;

    const [password, setPassword] = useState(
        window.location.href.includes("me.mavenregulatory.com") ? "12345" : ""
    );
    const [confirmPassword, setConfirmPassword] = useState(
        window.location.href.includes("me.mavenregulatory.com") ? "12345" : ""
    );

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleModal = () => {
        setOpen(!open);
        setPassword("");
        setConfirmPassword("");
        setShowPassword(false);
        setShowConfirmPassword(false);
    };

    const handlePasswordSubmit = async () => {
        if (password === confirmPassword && password !== "") {
            let reqObj = {
                password: password,
                clientUserId: userData?._id,
            };
            const uri = props?.commonUrl?.SIGN_IN;
            let result = await props?.ApiServices.callServicePostWithBodyData(uri, reqObj);
            if (result?.result?.type === "success") {
                showToast("ESign Added Successfully", true);
                handleSubmit(true, esignType);
                handleModal();
            } else {
                dispatchFunction(result);
            }
        } else {
            showToast("Passwords do not match or are empty");
        }
    };

    return (
        <div>
            <Button variant="contained" onClick={handleModal} style={{ marginLeft: "10px" }}>
                {buttonName ?? "E-Sign"}
            </Button>

            <CustomDialog open={open} onCancel={handleModal} maxWidth="sm">
                <DialogTitle>Enter Password To E-Sign</DialogTitle>
                <Divider />
                <DialogContent>
                    <TextField
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        fullWidth
                        sx={{ mb: 2 }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword((prev) => !prev)}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        label="Confirm Password"
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        fullWidth
                        sx={{ mb: 2 }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle confirm password visibility"
                                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                                        edge="end"
                                    >
                                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </DialogContent>
                <Divider />
                <DialogActions sx={{ p: 2.5 }}>
                    <Button variant="contained" color="error" onClick={handleModal}>
                        Close
                    </Button>
                    <Button variant="contained" color="success" onClick={handlePasswordSubmit}>
                        Submit
                    </Button>
                </DialogActions>
            </CustomDialog>
        </div>
    );
};

export default withRouter(ESign);
